import type { UserPermissions } from "@appType/types";

/**
 * Top-level Settings switch. `model` covers the model-level plane,
 * `partner` the partner-level one.
 */
export type SettingsView = "model" | "partner";

export const SETTINGS_VIEWS: SettingsView[] = ["model", "partner"];

export const isSettingsView = (value: unknown): value is SettingsView =>
	SETTINGS_VIEWS.includes(value as SettingsView);

/**
 * Partner settings' own profile section is root-only, but the plane itself
 * also opens for `model_settings` (to reach the Models roster) and
 * `ocr_settings` (to reach the OCR roster and drill into a profile's
 * field/stop-factor editor at /settings/ocr/$ocrId) — mirrors
 * resolveVisiblePartnerSections in pages/settings/types.ts, which decides
 * which sections each of those actually sees. The model plane stays open to
 * the scoring/model roles that owned it before the three pages were merged.
 */
export const VIEW_PERMISSIONS: Record<SettingsView, (keyof UserPermissions)[]> =
	{
		model: ["root", "model_settings", "scoring_settings"],
		partner: ["root", "model_settings", "ocr_settings"],
	};
